module.exports = __webpack_public_path__ + "static/media/Wild_For_Client_Page_(optimized)4.3da61a85.png";